import React from "react";
export const DocumentContextReact = React.createContext(undefined);
/*
 * Example of use
 *
import { DocumentContext } from "../../../components/document/document-context";

export class GeometryContentComponent extends BaseComponent<{}, {}> {

  public static contextType = DocumentContext;
  public declare context: React.ContextType<typeof DocumentContext>;

  public componentDidUpdate() {
    this.context && this.context.setProperties({ foo: "bar", baz: "roo" });
  }
}
*/
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZG9jdW1lbnQtY29udGV4dC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL2RvY3VtZW50L2RvY3VtZW50LWNvbnRleHQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sS0FBSyxNQUFNLE9BQU8sQ0FBQztBQUcxQixNQUFNLENBQUMsTUFBTSxvQkFBb0IsR0FBRyxLQUFLLENBQUMsYUFBYSxDQUErQixTQUFTLENBQUMsQ0FBQztBQUVqRzs7Ozs7Ozs7Ozs7Ozs7RUFjRSJ9